import WebFont from 'webfontloader';
import getStore from 'services/getStore';
import fonts from './fonts';
import parseFontUrl from './parseFontUrl';
import { loadAssets } from 'components/lib/BootScreen';

const store = getStore();
const { fontFamily = '', fontFamilies = [] } = store.getState().theme;

// fontFamilyMarks are any spans moving through slate
// we can refactor this to something faster later maybe
let fontFamilyMarks: string[] = [];

// any other reference to font or fontFamily that exists on a block's props
// indicates it is/was editable. capture it
let anyFontOrFontFamilyPropOnABlock: string[] = [];

Object.values(store.getState().blocks).forEach((b: any) => {
  const font = b?.props?.font || b?.props?.fontFamily;
  if (font) {
    anyFontOrFontFamilyPropOnABlock.push(b?.props?.font);
  }

  if (b.type === 'Text' && b?.props?.content) {
    const fontFamilyMark = b.props.content
      .split(/\<|\>/g)
      .filter((entry: any) => entry.includes('style="font-family:'))
      .map((entry: any) =>
        entry
          .replace(/\"|span|style|\=|font-family:|data-type|fontFamily/g, '')
          .trimStart()
          .trimEnd()
      )
      .filter((entry: any) => entry !== '');

    fontFamilyMarks = [...fontFamilyMarks, ...fontFamilyMark];
  }
});

// fontFamily is the font added to body
const userSelectedFonts = Array.from(
  new Set([
    fontFamily,
    ...fontFamilyMarks,
    ...anyFontOrFontFamilyPropOnABlock,
  ]) as any
).filter(f => {
  // filter out anything that might've returned an empty string ''
  return f;
});

// TODO
// turn this into a promise and move it out into own file ? . . .
const addFont = (url, targetWindow = window) => {
  if (!url) {
    return;
  }

  const { fontName, fontExtension, fontFormat } = parseFontUrl(url);

  // if it's default ( empty ) or is on the google fonts list ( fonts ). bail
  if (!fontName || fonts.includes(fontName)) {
    return fontName;
  }

  const head = targetWindow.document.querySelector('head')!;
  if (head.querySelector(`#${fontName}`)) {
    return;
  }

  const styleTag = document.createElement('style');

  styleTag.id = fontName;
  styleTag.innerHTML = `
    @font-face {
      font-family: "${fontName}";
      src: url("${url}") format("${fontFormat}");
    }
  `;

  head.appendChild(styleTag);

  return fontName;
};

let loadOnlyUserSelectedFonts =
  window.mode === 'PREVIEW' ||
  (window.parent === window && window.location.toString().match(/module/g));

const WebFontConfig = {
  google: {
    families: (loadOnlyUserSelectedFonts && userSelectedFonts.length
      ? fonts.filter(f => {
          return userSelectedFonts.includes(f);
        })
      : fonts
    ).map(f => `${f}:400,700`),
  },
  custom: {
    // families: fontFamilies,
  },
  loading: () => {},
  active: () => {
    loadAssets.loadFonts && loadAssets.loadFonts();
  },
  inactive: () => {
    console.log('NO UserSelectedFonts TO LOAD');
    loadAssets.loadFonts && loadAssets.loadFonts();
  },
  fontloading: (familyName, fvd) => {
    // console.log(familyName, fvd);
  },
  fontactive: (familyName, fvd) => {
    // console.log(familyName, fvd);
  },
  fontinactive: (familyName, fvd) => {
    // console.log(familyName, fvd);
  },
};

// boot these up. if any
if (!!fontFamilies.length) {
  fontFamilies.forEach(f => {
    addFont(f);
  });
}

console.log({
  'WebFontConfig.google.families': WebFontConfig.google.families,
  userSelectedFonts,
});

//
if (WebFontConfig.google.families.length) {
  WebFont.load(WebFontConfig);
}

export { addFont };
